import React from 'react';
import Hero from '../components/home/Hero';
import TrustBanner from '../components/home/TrustBanner';
import Testimonials from '../components/home/Testimonials';

export default function Home() {
  return (
    <div className="bg-white">
      <Hero />
      <TrustBanner />
      <div className="py-24 bg-slate-50">
        <Testimonials />
      </div>
    </div>
  );
}